module.exports = __webpack_public_path__ + "static/img/17.caddb92.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/huoban/17.png
// module id = haJH
// module chunks = 1